import React from "react";

export default function Facebook({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40.628"
      height="39.727"
      viewBox="0 0 40.628 39.727"
      className={className}
    >
      <path
        id="Path_302"
        data-name="Path 302"
        d="M967.5,8257.725V8246.9c0-3.016,0-3.105,2.988-2.979,1.441.054,1.986-.4,2.067-1.787.075-1.309.357-2.609.582-4.135-1.524,0-2.939-.055-4.344.018-.985.045-1.395-.262-1.3-1.273.075-.831-.019-1.679.031-2.519a2.8,2.8,0,0,1,2.785-2.979c.963-.126,1.946-.1,3.108-.153,0-1.453.038-2.854-.033-4.252a1.057,1.057,0,0,0-.711-.731,29.13,29.13,0,0,0-5.466-.145c-3.88.487-5.992,3.25-6.113,7.628-.037,1.4-.005,2.8-.005,4.407-1.331,0-2.527.072-3.708-.019-1.154-.09-1.484.361-1.4,1.436a21.849,21.849,0,0,1,0,3.179c-.064.965.245,1.372,1.272,1.309,1.194-.081,2.4-.026,3.714-.026v13.8c-8.349.045-16.862-9.725-16.959-19.411A20.148,20.148,0,0,1,963.826,8218c11.232-.162,20.522,8.5,20.8,19.312.3,11.764-9.027,19.646-17.124,20.413Z"
        transform="translate(-944 -8217.998)"
        fill="currentColor"
      />
    </svg>
  );
}
